import { createCtx } from "@reatom/core"
import { reatomContext } from "@reatom/npm-react"
import { PropsWithChildren } from "react"

export const ctx = createCtx()
export function ReatomContextProvider({ children }: PropsWithChildren<void>) {
    return <reatomContext.Provider value={ctx}>{children}</reatomContext.Provider>
}
